import { absolutePath } from "./absolutePath";

interface BlockedMembersFnProps {
  id?: string | number;
  params?: Record<string, unknown>;
}

export const blockedMembers = {
  index: ({ params = {} }: BlockedMembersFnProps = {}) =>
    absolutePath("blocked_members", params),
  create: ({ params = {} }: BlockedMembersFnProps = {}) =>
    absolutePath("blocked_members", params),
  destroy: ({ id, params = {} }: BlockedMembersFnProps = {}) =>
    absolutePath(`blocked_members/${id}`, params),
};
